<template>
  <div
    class="relative h-20"
    :class="{ '!h-12': !hasErrors}"
  >
    <div
      v-if="icon"
      class="ml-3 absolute h-12 flex place-items-center place-content-center"
    >
      <img
        :src="icon"
        class="h-5 w-5"
      >
    </div>
    <button
      id="dropdownMenuButton"
      :class="{'pl-11': icon}"
      class="ring-1 ring-[#CFCFCF] rounded h-12 px-5 w-full font-source-sans-pro focus:outline-none focus-within:bg-[#e8f0fe] hover:ring-gray group-hover:bg-[#e8f0fe] group-disabled:bg-semigray disabled:bg-semigray
        flex justify-start items-center group"
      type="button"
      @click="show()"
    >
      <p
        v-if="innerValue.from === null"
      >
        Dátum
      </p>
      <p v-else>
        <span v-if="innerValue.from !== null">{{
          innerValue.from | filterDay
        }}</span>
        -
        <span v-if="innerValue.to !== null">{{
          innerValue.to | filterDay
        }}</span>
      </p>
      <img
        src="/img/icons/inputs/dropdown_arrow_icon.svg"
        class="h-[16px] w-[16px] ml-auto transform transition-all group-hover:text-gray-darkest duration-500 "
        :class="{ 'rotate-180': hasFocus}"
      >
    </button>
    <div
      v-if="hasErrors"
      :class="{ '!h-[32px]': validationErrors }"
      class="w-4 font-source-sans-pro text-sm text-red transition-all h-[0px] duration-1000"
    >
      {{ validationErrors ? validationErrors[0] : "" }}
    </div>

    <div
      :class="{ 
        'ring-[#CFCFCF] max-h-[600px] p-5': hasFocus,
        'ring-transparent max-h-[0px] px-5 pb-0': !hasFocus
      }"
      class="z-50 absolute top-14 ring-1  bg-white rounded font-source-sans-pro
      transition-height duration-500 overflow-y-auto 
      flex flex-col w-[90vw] mx-auto md:w-full md:min-w-[500px] !overflow-hidden
      "
    >
      <DatePicker
        v-model="selectedDays"
        range-picker
        @clickedDate="checkDate($event)"
      />
      <div class="w-full flex items-center place-content-center gap-3">
        <button
          type="button"
          class="btn btn-red w-1/4"
          @click="clickCloseButton()"
        >
          Ok
        </button>
        <button
          type="button"
          class="btn btn-yellow w-1/4"
          @click="clickDeleteButton()"
        >
          Törlés
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import DatePicker from '~/components/rxt/reform/partials/DatePicker'
export default {
  components: {
    DatePicker
  },
  filters: {
    filterDay(value) {
      // return value.getFullYear()+"-"+value.getMonth()+1+"-"+value.getDate();
      return new Date(value).toLocaleDateString("hu");
    }
  },
  props: {
    // eslint-disable-next-line
    value: {
      validation: prop => {
        return prop instanceof Object || prop === null;
      },
      required: true
    },
    validationErrors: {
      type: Array,
      default: () => {
        return [];
      }
    },
    icon: {
      type: String,
      default: ""
    },
    hasErrors: {
      type: Boolean,
      default: true
    },
  },
  data() {
    return {
      hasFocus: false,
      visible2: false,
      innerValue: {
        from: null,
        to: null
      },
      selectedDays: []
    };
  },
  watch: {
    value: {
      handler(newValue) {
        if (newValue && newValue.from && newValue.to) {
          this.innerValue.from = newValue.from;
          this.innerValue.to = newValue.to;
        }
      },
      deep: true
    },
    selectedDays: {
      handler() {
        if(this.selectedDays.length !== 0){ 
          if(this.selectedDays.length === 1){ 
            this.innerValue.from = this.selectedDays[0]
          } else {
            this.innerValue.to = this.selectedDays[this.selectedDays.length - 1]
            this.$emit("input", this.innerValue);
            this.hasFocus = false;
          }
        }
      },
      deep: true
    }
  },
  beforeDestroy() {
    if (process.browser) {
      window.removeEventListener("click", this.close);
    }
  },
  beforeMount() {
    if (process.browser) {
      window.addEventListener("click", this.close);
    }
    if (this.value && this.value.from && this.value.to) {
      this.innerValue.from = this.value.from;
      this.innerValue.to = this.value.to;
    }
  },
  methods: {
    checkDate(date){
      if(this.innerValue.from && date === this.innerValue.from){
        this.innerValue.to = date
        this.$emit('input', this.innerValue)
        this.hasFocus = false;
      }
    },
    formatDate(year, month, day, format) {
      return this.$moment(year + "-" + month + "-" + day, "YYYY-MM-DD").format(
        format
      );
    },
    clickCloseButton() {
      this.hasFocus = false;
      if (this.innerValue.from !== null && this.innerValue.to === null) {
        this.innerValue.to = this.innerValue.from;
      }
      this.$emit("input", this.innerValue);
    },
    clickDeleteButton() {
      this.hasFocus = false;
      if (this.innerValue.from !== null && this.innerValue.to === null) {
        this.innerValue.to = this.innerValue.from;
      } else {
        this.innerValue.to = this.innerValue.from = null;
      }
      this.selectedDays = []
      this.$emit("input", { from: null, to: null });
    },
    close(e) {
      if (!this.$el.contains(e.target)) {
        if (this.innerValue.from !== null && this.innerValue.to === null) {
          this.innerValue.to = this.innerValue.from;
        }
        this.$emit("input", this.innerValue);
        this.hasFocus = false;
      }
    },
    show() {
      this.hasFocus = !this.hasFocus;
    }
  }
};
</script>
